module.exports = __webpack_public_path__ + "static/media/getbonus.0eb01265.png";